<template>
  <div id="insider-backtester-stock-restrictions-tab">
    <v-container fluid pa-0>
      <v-row>
        <!-- Optionally restrict to specific securities -->
        <v-col cols="12" mb-6>
          <helpers-section-sub-header class="mb-6">
            Optionally restrict to specific securities:
          </helpers-section-sub-header>

          <core-stock-manager v-model:stock-group="restrictTo" text no-padding />
        </v-col>

        <!-- Optionally exclude specific securities -->
        <v-col cols="12" mb-6>
          <helpers-section-sub-header class="mb-6">
            Optionally exclude specific securities:
          </helpers-section-sub-header>

          <core-stock-manager v-model:stock-group="excluded" flat no-padding />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  data() {
    return {
      restrictTo: [],
      excluded: []
    }
  },

  computed: {
    ...mapFields({
      criteria: 'app.insiderBacktesterCriteria'
    })
  },

  watch: {
    restrictTo(array) {
      this.criteria.entry_stocks = array
    },

    excluded(array) {
      this.criteria.excluded_stocks = array
    }
  }
}
</script>
